import {
  useCallback, useState 
} from "react"

export const useShowNotifyMeDialog = () => {
  const [notifyMeFormDialogIsOpen, setNotifyMeFormDialogIsOpen] = useState(false)

  const showNotifyMeFormDialog = useCallback(() => {
    setNotifyMeFormDialogIsOpen(true)
  }, [setNotifyMeFormDialogIsOpen])

  const hiddenNotifyMeFormDialog = useCallback(() => {
    setNotifyMeFormDialogIsOpen(false)
  }, [setNotifyMeFormDialogIsOpen])

  return {
    notifyMeFormDialogIsOpen,
    showNotifyMeFormDialog,
    hiddenNotifyMeFormDialog,
  }
}
